import { IAddressResponse } from "../types/profile";
import { getCountryInfo } from "./country";

export function formatAddress(address: IAddressResponse): string {
  const parts: string[] = [];

  // Add primary address line
  if (address.address) parts.push(address.address);

  // Add secondary address line if exists
  if (address.address2) parts.push(address.address2);

  // Add city/province and postal code
  const regionParts = [];
  if (address.province) regionParts.push(address.province);
  if (address.postalCode) regionParts.push(address.postalCode);

  if (regionParts.length > 0) {
    parts.push(regionParts.join(" "));
  }

  // Add country name
  if (address.countryCode) {
    try {
      const countryInfo = getCountryInfo(address.countryCode);
      if (countryInfo?.name) {
        parts.push(countryInfo.name);
      }
    } catch (error) {
      console.warn(
        `Failed to get country info for code: ${address.countryCode}`
      );
    }
  }

  return parts.join(", ");
}
